import { useContext } from 'react';
import AuthContext from '../contexts/AuthContext';

export const useAuth = () => {
  const context = useContext(AuthContext);
  
  // Debug logging
  // if (context && context.navigation) {
  //   console.log('[useAuth] Auth context navigation items:', context.navigation.length);
  // }
  
  return context;
};
